import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2010')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('drawing') || media.includes('painting');
  })
  .slice(0, 4);

export default function KakyoungLee() {
  const slides = [
    { src: '/uploads/2016/11/kakyoung_lee_8_walk-2010_2-big_1280x839.jpg', alt: 'KakyoungLee work 1' },
    { src: '/uploads/2016/11/Kakyoung_Lee_2.jpg', alt: 'KakyoungLee work 2' },
    { src: '/uploads/2016/11/Kakyoung_Lee_4.jpg', alt: 'KakyoungLee work 3' },
    { src: '/uploads/2016/11/Kakyoung_Lee_7.jpg', alt: 'KakyoungLee work 4' },
    { src: '/uploads/2016/11/Kakyoung_Lee_8.jpg', alt: 'KakyoungLee work 5' },
    { src: '/uploads/2016/11/Kakyoung_Lee_10.jpg', alt: 'KakyoungLee work 6' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Kakyoung Lee</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Kakyoung Lee slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2010</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Kakyoung Lee’s animations (or “moving images,” as the artist calls them) are based on her own experiences and are often focused on the repetitive nature of her own life and surroundings. We appreciated the quiet, meditative aspect of these videos and the combination of hand-drawn animations with local sound. The tender, human quality of these visions of everyday life is arresting and evident across a coherent body of work. It is particularly interesting to see how an artist who considers herself to have two home countries—South Korea and the United States—perceives her environment. We look forward to watching the continuing evolution of Lee’s art.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Carol Eliel, Curator of Modern Art, LACMA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Leah Ollman, Writer, Los Angeles Times and Art in America</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Bennett Simpson, Associate Curator, Museum of Contemporary Art Los Angeles</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Kakyoung Lee (b. 1975, Korea) received her BFA and MFA from Hong-Ik University, Seoul, as well as an MFA from SUNY-Purchase College, NY. She has exhibited in numerous exhibitions internationally, including at the Drawing Center, New York; Hofstra University, Hempstead; Kunsthalle Bremen, DE; Mass MOCA, North Adams; Metropolitan Museum of Art, New York; Museum of Contemporary Art, Banja Luka, Bosnia; Museum Folkwang, Essen, DE; Museum of Modern Art, New York; Oqbo, Berlin, DE; Queens Museum, New York; and Seoul Arts Center, Korea. She has also held residencies at the Marie Walsh Sharpe Space Program, ISCP, the Lower East Side Printshop (NY), Jamaica Center of Art for Learning, MacDowell Colony, and Yaddo. She has received grants from Pollock-Krasner Foundation, NYFA Fellowship, AHL Foundation, and the 2010 recipient of the KAFA Award. Lee’s works are in the public collections at The Cleveland Museum of Art, OH; McNay Art Museum, TX; the Metropolitan Museum of Art, NYC; and Library of Congress, Washington D.C. among others.</p>

            <a href='https://kakyounglee.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
